import { render, staticRenderFns } from "./MiniChart.vue?vue&type=template&id=2ddb1677&scoped=true&"
import script from "./MiniChart.vue?vue&type=script&lang=js&"
export * from "./MiniChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb1677",
  null
  
)

export default component.exports